












































import { Component, Vue, ProvideReactive } from 'vue-property-decorator';
import EmployeeForm from '@/components/Employee/EmployeeForm.vue';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_createEmployee } from '@/queries/__generated__/createEmployee';

import EmployeeSearch from '@/components/Employee/EmployeeSearch.vue';
import unitPaycheckLineTemplateRequiredGuard from '@/guards/unit-paycheck-line-template-required-guard';
import permissionGuard from '@/guards/permission-guard';
import PermissionService from '@/utils/permission-service';
import gql from 'graphql-tag';

const CREATE_EMPLOYEE = gql`
  mutation createEmployee($employee: EmployeeCreate!) {
    createEmployee(input: { employee: $employee }) {
      employee {
        id
      }
    }
  }
`;

@Component({
  components: {
    EmployeeForm,
    EmployeeSearch,
  },
  beforeRouteEnter: (to, from, next) => {
    permissionGuard('canEditEmployees', to, from, next)
      .then(() => {
        unitPaycheckLineTemplateRequiredGuard(to, from, next);
      }).catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class EmployeesNew extends Vue {
  private CREATE_EMPLOYEE = CREATE_EMPLOYEE;

  private validForm = true;

  @ProvideReactive()
  private get editable(): boolean {
    return PermissionService.check('canEditEmployees');
  }

  private employeeCreated(store: InMemoryCache, query: {data: GQL_createEmployee }): void {
    const employee = query.data.createEmployee!.employee!;

    this.$sMessage.success(this.$t('Message.saveSuccess'));
    this.$router.push(`/employees/${employee.id}?new_employee=true`);
  }
}
